// extracted by mini-css-extract-plugin
module.exports = {"user-modal":"tenant-modal_user-modal__1oFum","userModal":"tenant-modal_user-modal__1oFum"};